import { SelectedMsisdnInterfaceState, initialSelectedMsisdnState } from '../state/selected-msisdn.state';
import { SelectedMsidnActions, ESelectedMsidnActions } from '../actions/selected-msidn.actions';

export function selectedMsisdnReducer(state: SelectedMsisdnInterfaceState = initialSelectedMsisdnState, action: SelectedMsidnActions): SelectedMsisdnInterfaceState {
  switch (action.type) {
    case ESelectedMsidnActions.SetSelectedPhoneNumber: {
      return { ...state, phoneNumber: action.payload };
    }

    default:
      return state;
  }
};
